import { ScrollCaptain } from 'scroll-captain';
import { smoothScrollTo } from '../utilities/helper';

class FloatingBar {
    constructor(element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-research-ai-landingpage-floatingbar',
            targetValue: 'cta',
            autoselectValue: 'autoselect',
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.animation = null;

        // Elements
        this.$floatingBar = element;
        this.$button = document.querySelector(`[${ this.settings.initAttr }="${ this.settings.targetValue }"]`);
        this.$autoselectOption = null;
    }

    initialize() {
        this.toggleCta();
        this.setEvents();
    }

    toggleCta() {
        this.animation = new ScrollCaptain(this.$floatingBar, {
            initAttr: this.settings.initAttr,
            bottom: '-150%',
            top: '-150%',
            animateCta: {
                globalTarget: true,
                targetSuffix: this.settings.targetValue,
                resetOnScrollDown: false,
                class: 'researchAiLandingpage-floatingBar--inview',
            },
        });
    }

    setEvents() {
        if (this.$button) {
            this.$button.addEventListener('click', () => {
                this.$autoselectOption = document.querySelector(`[${ this.settings.initAttr }="${ this.settings.autoselectValue }"]`);
                smoothScrollTo(0, 0, 800);

                if (this.$autoselectOption) {
                    window.setTimeout(() => {
                        this.$autoselectOption.click();
                    }, 600);
                }
            });
        }
    }
}

export { FloatingBar };
